export default {
    headers: {
        backToOrganizations: {
            id: 'organization.headers.backToOrganizations'
        },
        chooseBusinessEmail: {
            id: 'organization.headers.chooseBusinessEmail'
        },
        chooseOrganization: {
            id: 'organization.headers.chooseOrganization'
        },
        createOrganization: {
            id: 'organization.headers.createOrganization'
        },
        createOrganizationSent: {
            id: 'organization.headers.createOrganizationSent'
        },
        invitationMemberships: {
            id: 'organization.headers.invitationMemberships'
        },
        joiningToOrganization: {
            id: 'organization.headers.joiningToOrganization'
        },
        joinOrganization: {
            id: 'organization.headers.joinOrganization'
        },
        joinOrCreateOrganization: {
            id: 'organization.headers.joinOrCreateOrganization'
        },
        leaveOnlyAdmin: {
            id: 'organization.headers.leaveOnlyAdmin'
        },
        leaveOrganization: {
            id: 'organization.headers.leaveOrganization'
        },
        logoAdjust: {
            id: 'organization.headers.logoAdjust'
        },
        logoUpload: {
            id: 'organization.headers.logoUpload'
        },
        organizationBasicInfo: {
            id: 'organization.headers.organizationBasicInfo'
        },
        organizationAddress: {
            id: 'organization.headers.organizationAddress'
        },
        organizationMembershipInfo: {
            id: 'organization.headers.organizationMembershipInfo'
        },
        waitForAdminApproval: {
            id: 'organization.headers.waitForAdminApproval'
        }
    },
    steps: {
        create: {
            Country: {
                id: 'organization.steps.create.Country'
            },
            Information: {
                id: 'organization.steps.create.Information'
            },
            RequestSent: {
                id: 'organization.steps.create.RequestSent'
            },
            Summary: {
                id: 'organization.steps.create.Summary'
            }
        }
    },
    buttons: {
        approveMembership: {
            id: 'organization.buttons.approveMembership'
        },
        rejectMembership: {
            id: 'organization.buttons.rejectMembership'
        },
        createOrganization: {
            id: 'organization.buttons.createOrganization'
        },
        joinOrganization: {
            id: 'organization.buttons.joinOrganization'
        },
        leaveOrganization: {
            id: 'organization.buttons.leaveOrganization'
        }
    },
    labels: {
        approved: {
            id: 'organization.labels.approved'
        },
        rejected: {
            id: 'organization.labels.rejected'
        },
        businessEmail: {
            id: 'organization.labels.businessEmail'
        },
        organizationId: {
            id: 'organization.labels.organizationId'
        },
        organizationList: {
            id: 'organization.labels.organizationList'
        },
        language: {
            id: 'organization.labels.language'
        },
        name: {
            id: 'organization.labels.name'
        },
        logo: {
            id: 'organization.labels.logo'
        },
        scope: {
            id: 'organization.labels.scope'
        },
        searchOrganization: {
            id: 'organization.labels.searchOrganization'
        },
        city: {
            id: 'organization.labels.city'
        },
        state: {
            id: 'organization.labels.state'
        },
        street: {
            id: 'organization.labels.street'
        },
        zipCode: {
            id: 'organization.labels.zipCode'
        }
    },
    placeholders: {
        businessEmail: {
            id: 'organization.placeholders.businessEmail'
        },
        name: {
            id: 'organization.placeholders.name'
        },
        city: {
            id: 'organization.placeholders.city'
        },
        state: {
            id: 'organization.placeholders.state'
        },
        street: {
            id: 'organization.placeholders.street'
        },
        zipCode: {
            id: 'organization.placeholders.zipCode'
        },
        searchOrganization: {
            id: 'organization.placeholders.searchOrganization'
        }
    },
    tags: {
        admin: {
            id: 'organization.tags.admin'
        },
        invitation: {
            id: 'organization.tags.invitation'
        },
        notApproved: {
            id: 'organization.tags.notApproved'
        },
        pending: {
            id: 'organization.tags.pending'
        },
        rejected: {
            id: 'organization.tags.rejected'
        }
    },
    infos: {
        createOrganization: {
            id: 'organization.infos.createOrganization'
        },
        createOrganizationLead: {
            id: 'organization.infos.createOrganizationLead'
        },
        createOrganizationSubLead: {
            id: 'organization.infos.createOrganizationSubLead'
        },
        createOrganizationSent: {
            id: 'organization.infos.createOrganizationSent'
        },
        joinOrganizationSent: {
            id: 'organization.infos.joinOrganizationSent'
        },
        waitForAdminApproval: {
            id: 'organization.infos.waitForAdminApproval'
        }
    },
    intros: {
        chooseBusinessEmail: {
            id: 'organization.intros.chooseBusinessEmail'
        },
        findOrganization: {
            id: 'organization.intros.findOrganization'
        },
        invitationMemberships: {
            id: 'organization.intros.invitationMemberships'
        },
        joinOrganization: {
            id: 'organization.intros.joinOrganization'
        },
        leaveOnlyAdmin: {
            id: 'organization.intros.leaveOnlyAdmin'
        },
        leaveOrganization: {
            id: 'organization.intros.leaveOrganization'
        },
        create: {
            provideCountry: {
                id: 'organization.intros.create.provideCountry'
            },
            summary: {
                id: 'organization.intros.create.summary'
            }
        }
    },
    alerts: {
        leaveOrganizationSuccess: {
            id: 'organization.alerts.leaveOrganizationSuccess'
        }
    }
};
